export const getModalType = state => state.modal.modalType;
export const getModalState = state => state.modal.modalState;


// WEBPACK FOOTER //
// ./src/selectors/modal.js